<template>
  <div class="tpl">
    <van-nav-bar title="订单详情" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <div class="status">
      <div>{{item.status_str}}</div>
      <div v-if="item.status==2">商户承诺48小时内发货</div>
      <div style="display:flex;" v-if="showPay">
        <div>您还剩下：</div>
        <van-count-down
          style="color:#ffffff"
          millisecond
          @finish="showPay=false"
          :time="payTime"
          format="HH:mm:ss:SS"
        />
        <div style="padding:0 0 0 30px;">
          <van-button type="primary" size="small" v-on:click="payPanlShow=true">立即支付</van-button>
        </div>
      </div>
      <van-popup
        v-model="payPanlShow"
        round
        closeable
        position="bottom"
        style="height:220px;color:#000; text-align:center"
      >
        <div style=";font-size:16px;padding-top:10px;">付款详情</div>
        <div style="padding:30px 0 10px 0">
          ¥
          <span style="font-size:50px;font-weight:blod">{{item.amount}}</span>
        </div>
        <div style="padding:10px;">
          <van-button type="info" size="large" v-on:click="againPay()">立即支付</van-button>
        </div>
      </van-popup>
    </div>
    <div class="wuliu" v-if="item.status>2">
      <div class="l">
        <i class="iconfont iconfahuotixing"></i>
      </div>
      <div class="r">
        <div>
          物流：{{item.express_name}}
          <span style="padding-left:10px;">单号：{{item.express_number}}</span>
        </div>
        <div>{{item.send_time}}</div>
      </div>
    </div>
    <div class="address">
      <div class="l">
        <i class="iconfont iconweizhi"></i>
      </div>
      <div class="r">
        <div>
          {{item.name}}
          <span style="padding-left:10px; color:#888888">{{item.mobile}}</span>
        </div>
        <div>{{item.area}}{{item.address}}</div>
      </div>
    </div>
    <div class="goods">
      <div>{{moduleList[item.module]}} 订单编号：{{item.id}}</div>
      <div class="goods">
        <div class="g" v-for="g in item.detail" :key="g.id">
          <div class="l">
            <van-image width="100px" height="100px" fit="contain" :src="GLOBAL.IMG + g.thumb" />
          </div>
          <div class="r">
            <router-link class="title" :to="'/'+routerUrl+'/detail/'+g.goods_id">{{g.title}}</router-link>
            <div class="attr_price">
              <div>{{g.spec}}</div>
              <div
                style="color:red;flex-grow:1; text-align:right; padding-right:20px"
              >{{g.price}} × {{g.number}}</div>
              <div>
                <van-button
                  type="default"
                  size="mini"
                  v-on:click="$router.push('/user/orderComment/'+item.module+'/'+item.id + '/'+ g.goods_id)"
                >评论</van-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>共{{item.num}}件，总金额：{{item.amount}}</div>
    </div>
    <div class="pay">
      <van-button type="default" v-if="item.status==3" v-on:click="confirmGoods()">确认收货</van-button>
      <van-button type="default" v-if="item.status==2||item.status==3||item.status==4" v-on:click="returnGoods()">退货申请</van-button>
      <van-button type="default" v-if="item.status==3" v-on:click="getExpress()">查看物流</van-button>
      <van-button type="default" v-on:click="againBuy()">再来一单</van-button>
    </div>
    <div class="express">
      <div style="padding:10px">{{expressList.company}}</div>
      <div class="group" v-for="item in expressList.detail" :key="item.id">
        <div class="left">{{item.time}}</div>
        <div class="right">{{item.desc}}</div>
      </div>
    </div>
    <van-dialog
      v-model="returnGoodsShow"
      title="退货原因"
      show-cancel-button
      :beforeClose="beforeClose"
    >
      <van-field
        v-model="returnGoodsReason"
        rows="2"
        autosize
        type="textarea"
        maxlength="50"
        placeholder="请输入退货理由"
        show-word-limit
      />
    </van-dialog>
    <div style="height:60px;"></div>
    <DPtabbar active="4"></DPtabbar>
  </div>
</template>
<script>
import DPtabbar from "@/components/TabBar.vue";
import Vue from "vue";
import { CountDown } from "vant";
import { Popup } from "vant";
import { Dialog } from "vant";

Vue.use(Popup);
Vue.use(CountDown);
export default {
  name: "orderList",
  components: {
    DPtabbar,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      user: { token: "", user: {} },  // e09a79e47b38941404f8e0372d5f5fa009ec7c1f19759430d403578d126636be
      id: this.$route.params.id,
      module: this.$route.params.module,
      routerUrl: "",
      item: {},
      moduleList: ["", "亿起购", "亿起抢", "亿起团"], //1亿起购，2亿起抢，3亿起团
      expressList: {company:'',detail:[]},
      payTime: 0,
      showPay: true,
      payPanlShow: false,
      returnGoodsShow: false, //控制退货dialog显示
      returnGoodsReason: "",
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },

    getOrder() {
      this.$http
        .get(this.GLOBAL.API + "s_user/order/detail", {
          params: { id: this.id, module: this.module },
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" },
        })
        .then((response) => {
          let data = response.body;
          if (data.code == 1) {
            this.item = data.data;
            this.payTime = 30 * 60 * 1000 - data.data.pay_sy_time * 1000;
            // this.payTime = 10000000;
            if (this.payTime > 0 && data.data.status == 1) {
              this.showPay = true;
            }
          } else {
            this.$toast(data.msg);
          }
        });
    },
    againBuy() {
      this.$router.push(
        "/" + this.routerUrl + "/detail/" + this.item.detail[0].goods_id
      );
    },
    againPay() {
      let moduleName = "s_shop";
      if (this.module == 2) {
        moduleName = "s_qiang";
      }
      this.$http
        .post(
          this.GLOBAL.API + moduleName + "/order/againPay",
          { orderId: this.item.id },
          {
            params: {},
            headers: {
              "XX-Token": this.user.token,
              "XX-Device-Type": "mobile",
            },
          }
        )
        .then((response) => {
          let data = response.body;
          if (data.code == 1) {
            this.wxPay(data.data);
          } else {
            this.$toast(data.msg);
          }
        });
    },
    wxPay(id) {
      window.location.replace(this.GLOBAL.URL + "/pay/index/index/id/" + id);
    },
    confirmGoods() {
      this.$http
        .post(
          this.GLOBAL.API + "s_user/order/confirm",
          { id: this.id, module: this.module },
          {
            params: { id: this.id, module: this.module },
            headers: {
              "XX-Token": this.user.token,
              "XX-Device-Type": "mobile",
            },
          }
        )
        .then((response) => {
          let data = response.body;
          if (data.code == 1) {
            this.$toast(data.msg);
            this.getOrder();
          } else {
            this.$toast(data.msg);
          }
        });
    },
    returnGoods() {
      this.returnGoodsShow = true;
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        if (!this.returnGoodsReason) {
          this.$toast("请输入退货原因");
          done(false);
        } else {
          this.$http
            .post(
              this.GLOBAL.API + "s_user/order/returnRequest",
              { id: this.id, module: this.module },
              {
                params: {
                  id: this.id,
                  module: this.module,
                  reason: this.returnGoodsReason,
                },
                headers: {
                  "XX-Token": this.user.token,
                  "XX-Device-Type": "mobile",
                },
              }
            )
            .then((response) => {
              let data = response.body;
              if (data.code == 1) {
                done();
                this.$toast(data.msg);
                this.getOrder();
              } else {
                done();
                this.$toast(data.msg);
              }
            });
        }
        // setTimeout(done, 1000);
      } else {
        done();
      }
    },

    getExpress() {
      this.$http
        .get(this.GLOBAL.API + "/user/express/logistics", {
          params: {
            id: this.id,
            module: this.module,
            express_number: this.item.express_number,
          },
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" },
        })
        .then((response) => {
          let data = response.body;
          if (data.code == 1) {
            this.expressList = data.data;
          } else {
            this.$toast(data.msg);
          }
        });
    },
  },
  mounted() {
    this.routerUrl = this.module == 1 ? "shop" : "qiang";
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
    this.getOrder();
  },
};
</script>
<style lang="scss" scoped>
.tpl {
  height: 100%;
  background-color: #f6f6f6;
  text-align: left;
}
.status {
  background-color: #1baeae;
  padding: 10px;
  color: #fff;
}
.wuliu {
  background-color: #fff;
  padding: 10px;
  line-height: 23px;
  display: flex;
  color: #3697e0;
  .l {
    align-self: center;
    padding: 0 10px 0 0px;
    .iconfont {
      font-size: 30px;
    }
  }
}
.address {
  background-color: #fff;
  padding: 10px;
  line-height: 23px;
  display: flex;
  .l {
    align-self: center;
    padding: 0 10px 0 0px;
    .iconfont {
      font-size: 30px;
      color: #1baeae;
    }
  }
}
.goods {
  margin-top: 10px;
  background-color: #fff;
  padding: 10px;
  .g {
    margin-top: 5px;
    display: flex;
    .l {
      width: 100px;
    }
    .r {
      flex-grow: 1;
      margin-left: 20px;
      .title {
        line-height: 25px;
        height: 50px;
        overflow: hidden;
        color: #222333;
      }
      .attr_price {
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
.pay {
  margin-top: 10px;
  background-color: #fff;
  padding: 10px;
  button {
    margin-right: 10px;
  }
}
.express {
  margin-top: 10px;
  .group {
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    margin-bottom: 10px;
    width: 100%;
    padding: 10px;
    .left {
      width: 30%;
      text-align: center;
    }
    .right {
      width: 70%;
    }
  }
}
</style>